export default {"src":"/_next/static/media/hotspot-button-small.9baab6bb.svg","height":30,"width":30};